import React, { useState } from 'react';
import { Localizer } from 'services/Localizer';
import Alert from 'shared/components/Alert';
import Spinner from 'shared/components/Spinner';
import { ShoppingListEditItemFields } from './ShoppingListEditItemFields';
import { ShoppingListEditItemBodyProps } from './ShoppingListEditItem';

export default function ShoppingListEditItemBody(props: ShoppingListEditItemBodyProps) {
	const [isAlertOpen, setIsAlertOpen] = useState<boolean>(false);

	const {
		displayCancelButton,
		displaySaveButton,
		stopEditingShoppingList,
		onRemoveShoppingList,
		isSaving,
		dirty,
		dirtySaveButtonText,
		saveButtonText,
		shoppingListBeingEdited,
		isDeleting,
	} = props;
	return (
		<>
			<p data-testid={'shopping-list-required-fields'}>{Localizer('RequiredFields')}</p>

			<ShoppingListEditItemFields />

			<div className="roc-modal__actions">
				{onRemoveShoppingList ? (
					<>
						<div className="roc-modal__actions-item">
							<button
								type="button"
								className="roc-btn roc-modal__actions-item-btn roc-btn-danger"
								disabled={isSaving || isDeleting}
								onClick={() => {
									setIsAlertOpen(true);
								}}
								data-testid="shopping-list-delete-button"
							>
								{isDeleting && <Spinner />}
								{Localizer('Delete')}
							</button>
						</div>

						<Alert
							isOpen={isAlertOpen}
							renderTitle={() => Localizer('DeleteShoppingList')}
							onCancel={() => setIsAlertOpen(false)}
							onConfirm={() => {
								setIsAlertOpen(false);

								onRemoveShoppingList(shoppingListBeingEdited);
							}}
							theme="danger"
							confirmButtonText={Localizer('Delete')}
						>
							{Localizer('DeleteShoppingListConfirmationQuestion')}
						</Alert>
					</>
				) : null}
				{displayCancelButton ? (
					<div className="roc-modal__actions-item">
						<button
							type="button"
							color="primary-alt"
							className="roc-btn roc-modal__actions-item-btn  roc-modal__btn-cancel"
							data-testid="shopping-list-cancel-button"
							onClick={() => {
								stopEditingShoppingList();
							}}
						>
							{Localizer('Cancel')}
						</button>
					</div>
				) : null}
				{displaySaveButton ? (
					<div className="roc-modal__actions-item">
						<button
							type="submit"
							color="secondary"
							className="roc-btn roc-modal__actions-item-btn roc-modal__btn-confirm"
							disabled={isSaving || isDeleting}
							data-testid="shopping-list-save-button"
						>
							{dirty ? dirtySaveButtonText : saveButtonText}

							{isSaving && <Spinner light />}
						</button>
					</div>
				) : null}
			</div>
		</>
	);
}

ShoppingListEditItemBody.defaultProps = {
	displayCancelButton: true,
	displaySaveButton: true,
	saveButtonText: Localizer('Save'),
	dirtySaveButtonText: Localizer('Save'),
};
